<template>
    <div class="completed-content">
        <div class="completed-title">
            Поздравляем!
        </div>
        <p class="completed-text">
            Вы завершили обучение для достижения поставленной цели и поднялись на вершину, выполнив все задания.
        </p>
        <p class="completed-text">
            Если вы хотите продолжить обучение, добавьте в трек новые цели или образовательные программы.
        </p>
        <router-link
            :to="{ name: 'profession-list' }"
            class="blue-button completed-button"
        >
            Продолжить обучение
        </router-link>
    </div>
</template>

<script>
export default {
    name: "TimeLineCompletedEmpty",
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";

.completed {
    &-content {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        padding: 48px 14% 514px 14%;
        background: url("~@/assets/images/account-track/completed-timeline-bg-mobile.svg") no-repeat center bottom/contain;

        @include on-xs {
            padding: 8px 16px 308px 16px;
        }
    }

    &-title {
        margin: 0 0 16px 0;
        font-weight: 600;
        font-size: 22px;
        line-height: 30px;
        text-align: center;
        color: #2A2626;
    }

    &-text {
        margin: 0 0 8px 0;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        color: #2A2626;
    }

    &-button {
        width: 256px;
        height: 40px;
        margin: 16px 0 0 0;
        border-radius: 4px;
        font-size: 16px;
        line-height: 24px;
    }
}
</style>